<template lang="pug">
	.side-nav-outer-toolbar
		header-toolbar.layout-header(
			:menu-toggle-enabled="false"
			:toggleMenuFunc="toggleMenuFunc"
			:title="title")
		dx-scroll-view.with-footer(:useNative="false" direction="both")
			.scroll-content
				slot
			slot(name="footer")
		.app-version.font-tiny Version {{$auth.getVersion()}}
</template>

<script>
import DxScrollView from 'devextreme-vue/scroll-view';

import HeaderToolbar from '../components/header-toolbar.vue';

export default {
	components: {
		DxScrollView,
		HeaderToolbar
	},
	props: {
		title: String,
		isXSmall: Boolean,
		isLarge: Boolean
	},
	data() {
		return {
			
		};
	},
	computed: {
	},
	watch: {				
	},
	methods: {
		toggleMenuFunc() {
		}
	}
};
</script>

<style lang="scss">
	.side-nav-outer-toolbar {
		flex-direction: column;
		display: flex;
		height: 100%;
		width: 100%;

		> .app-version {
			position: fixed;
			right: 10px;
			bottom: 6px;
			color: rgba(0,0,0,0.4);
			pointer-events: none;
		}
	}

	.layout-header {
		z-index: 1501;
	}

	.layout-body {
		flex: 1;
		min-height: 0;
	}

	.content {
		flex-grow: 1;
	}
</style>
